import React from 'react'
import { Box, Grid, Typography } from '@mui/material'

// Compact label/value grid. Rows: { label, value, fullWidth, render }.
// Empty values are hidden unless `showEmpty`; `emptyText` shows when nothing
// is left to display.
const isEmpty = (value) =>
  value === undefined || value === null || value === '' || value === false

const KeyValueList = ({
  rows = [],
  columns = 2,
  showEmpty = false,
  emptyText = 'Nothing recorded yet.',
}) => {
  const visible = rows.filter((row) => row && (showEmpty || !isEmpty(row.value) || row.render))
  if (visible.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyText}
      </Typography>
    )
  }
  const span = 12 / columns
  return (
    <Grid container spacing={1.5}>
      {visible.map((row) => (
        <Grid item xs={12} sm={row.fullWidth ? 12 : span} key={row.label}>
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.06em',
              fontSize: '0.66rem',
              display: 'block',
            }}
          >
            {row.label}
          </Typography>
          {row.render ? (
            <Box marginTop={0.25}>{row.render}</Box>
          ) : (
            <Typography
              variant="body2"
              sx={{
                color: isEmpty(row.value) ? 'text.disabled' : 'text.primary',
                fontWeight: 500,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {isEmpty(row.value) ? '—' : String(row.value)}
            </Typography>
          )}
        </Grid>
      ))}
    </Grid>
  )
}

export default KeyValueList
